import { Record } from 'immutable';

export default class BookingInvoiceItemAttestedDateRecord extends Record({
  id: undefined,
  date: undefined,
  invoice: undefined,
  price: undefined,
}) {
}
